import React, { createContext, useContext, useState } from 'react';

const translations = {
  RU: {
    siteTitle: 'bongastream',
    viewers: 'зрителей',
    name: 'Имя',
    age: 'Возраст',
    height: 'Рост',
    hairColor: 'Цвет волос',
    hobby: 'Хобби',
    subscribe: 'Подписаться',
    freeAccess: 'Бесплатный доступ',
    requestAccess: 'Запросить доступ',
    supportModel: 'Поддержать модель',
    login: 'Войти',
    signup: 'Регистрация',
    profile: 'Мой профиль',
    settings: 'Настройки',
    logout: 'Выйти',
    publicChat: 'Открытый чат',
    privateShow: 'Приватное шоу',
    sendTokens: 'Отправить токены',
    vipClub: 'VIP Клуб',
    play: 'Нажмите, чтобы начать просмотр',
    privateAccessTitle: 'Приватный доступ предоставлен',
    privateAccessBody: (name) => `Поздравляем! ${name} предоставил(а) доступ к приватной галерее.`,
    enterGallery: 'Войти в галерею',
    close: 'Закрыть',
    privateAccessShort: 'Приватный доступ предоставлен',
    terms: 'Условия',
    privacy: 'Конфиденциальность',
    support: 'Поддержка',
    contact: 'Контакты',
    allRights: 'Все права защищены.',
    follow: 'Подписаться',
    pinModel: 'Закрепить модель',
    notifyWhenOnline: 'Уведомлять при онлайн',
    privateMessage: 'Приватное сообщение',
    sendTip: 'Отправить',
    tip: 'Чаевые',
    tokenLabel: 'токен',
    byToken: 'купить токен',
    searchModelPlaceholder: 'Поиск модели',
    gender: 'Пол',
    Female: 'Женщина',
    interestedIn: 'Интересует',
    pubicHair: 'Лобковые волосы',
    bust: 'Грудь',
    butt: 'Ягодицы',
    interestsTitle: 'Интересы',
    showMore: 'Показать ещё ▾',
    fanBoost: 'FAN BOOST',
    helpBadge: '?',
    bodyTypeSlim: 'Стройная',
    yrs: 'лет',
    modalChatMsg: 'Чтобы участвовать в чате, войдите через Telegram',
    modalPrivateMsg: 'Для доступа к приватному шоу войдите через Telegram',
    modalTokensMsg: 'Чтобы отправить токены, войдите через Telegram',
    modalVipMsg: 'Для доступа к VIP Клубу войдите через Telegram',
    modalFollowMsg: 'Чтобы подписаться, войдите через Telegram',
    modalSocialMsg: 'Для просмотра соц. сетей войдите через Telegram',
    registerPrompt: 'Чтобы пользоваться услугами сайта, нужно зарегистрироваться',
  },
  EN: {
    siteTitle: 'bongastream',
    viewers: 'viewers',
    name: 'Name',
    age: 'Age',
    height: 'Height',
    hairColor: 'Hair color',
    hobby: 'Hobby',
    subscribe: 'Subscribe',
    freeAccess: 'Free Access',
    requestAccess: 'Request Access',
    supportModel: 'Support Model',
    login: 'Login',
    signup: 'Sign Up',
    profile: 'My Profile',
    settings: 'Settings',
    logout: 'Logout',
    publicChat: 'Public Chat',
    privateShow: 'Private Show',
    sendTokens: 'Send Tokens',
    vipClub: 'VIP Club',
    play: 'Click to play',
    privateAccessTitle: 'Private access granted',
    privateAccessBody: (name) => `Congratulations! ${name} has granted access to the private gallery.`,
    enterGallery: 'Enter Gallery',
    close: 'Close',
    privateAccessShort: 'Private access granted',
    terms: 'Terms',
    privacy: 'Privacy',
    support: 'Support',
    contact: 'Contact',
    allRights: 'All rights reserved.',
    follow: 'Follow',
    pinModel: 'Pin model',
    notifyWhenOnline: 'Notify when online',
    privateMessage: 'Private Message',
    sendTip: 'Send Tip',
    tip: 'Tip',
    tokenLabel: 'token',
    byToken: 'by token',
    searchModelPlaceholder: 'Search model',
    gender: 'Gender',
    Female: 'Female',
    interestedIn: 'Interested in',
    pubicHair: 'Pubic hair',
    bust: 'Bust',
    butt: 'Butt',
    interestsTitle: 'Interests',
    showMore: 'Show more ▾',
    fanBoost: 'FAN BOOST',
    helpBadge: '?',
    bodyTypeSlim: 'Slim',
    yrs: 'yrs',
    modalChatMsg: 'Login via Telegram to join the chat',
    modalPrivateMsg: 'Login via Telegram to access private show',
    modalTokensMsg: 'Login via Telegram to send tokens',
    modalVipMsg: 'Login via Telegram to access VIP Club',
    modalFollowMsg: 'Login via Telegram to follow',
    modalSocialMsg: 'Login via Telegram to view social links',
    registerPrompt: 'To use the site services you must register',
  },
  ES: {
    siteTitle: 'bongastream',
    viewers: 'espectadores',
    name: 'Nombre',
    age: 'Edad',
    height: 'Altura',
    hairColor: 'Color de pelo',
    hobby: 'Hobbie',
    subscribe: 'Suscribirse',
    freeAccess: 'Acceso gratis',
    requestAccess: 'Solicitar acceso',
    supportModel: 'Apoyar modelo',
    login: 'Entrar',
    signup: 'Registrarse',
    profile: 'Mi perfil',
    settings: 'Ajustes',
    logout: 'Cerrar sesión',
    publicChat: 'Chat público',
    privateShow: 'Espectáculo privado',
    sendTokens: 'Enviar tokens',
    vipClub: 'Club VIP',
    play: 'Haz clic para ver',
    privateAccessTitle: 'Acceso privado concedido',
    privateAccessBody: (name) => `¡Felicidades! ${name} ha concedido acceso a la galería privada.`,
    enterGallery: 'Entrar a la galería',
    close: 'Cerrar',
    privateAccessShort: 'Acceso privado concedido',
    terms: 'Términos',
    privacy: 'Privacidad',
    support: 'Soporte',
    contact: 'Contacto',
    allRights: 'Todos los derechos reservados.',
    follow: 'Seguir',
    pinModel: 'Fijar modelo',
    notifyWhenOnline: 'Notificar cuando esté en línea',
    privateMessage: 'Mensaje privado',
    sendTip: 'Enviar donación',
    tip: 'Tip',
    tokenLabel: 'token',
    byToken: 'por token',
    searchModelPlaceholder: 'Buscar modelo',
    gender: 'Yo',
    Female: 'Femenina',
    interestedIn: 'Interesado en',
    pubicHair: 'Vello púbico',
    bust: 'Pecho',
    butt: 'Nalgas',
    interestsTitle: 'Intereses',
    showMore: 'Mostrar más ▾',
    fanBoost: 'FAN BOOST',
    helpBadge: '?',
    bodyTypeSlim: 'Delgada',
    yrs: 'años',
    modalChatMsg: 'Inicia sesión vía Telegram para unirte al chat',
    modalPrivateMsg: 'Inicia sesión vía Telegram para acceder al show privado',
    modalTokensMsg: 'Inicia sesión vía Telegram para enviar tokens',
    modalVipMsg: 'Inicia sesión vía Telegram para acceder al Club VIP',
    modalFollowMsg: 'Inicia sesión vía Telegram para seguir',
    modalSocialMsg: 'Inicia sesión vía Telegram para ver redes sociales',
    registerPrompt: 'Para utilizar los servicios del sitio, debe registrarse',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('RU');

  const t = (key, ...args) => {
    const set = translations[lang] || translations.RU;
    const val = set[key];
    if (typeof val === 'function') return val(...args);
    return val ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

export default LanguageContext;
